/**
 * 客户关怀表单组件
 */

import React from 'react';
import { Card, Form, Input, Button, Upload, Space, Select } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/es/upload/interface';
import type { CareType, CustomerCareRecord } from '../types';

const { TextArea } = Input;

interface CustomerCareFormProps {
    careType: CareType;
    form: any;
    loading: boolean;
    editingRecord: CustomerCareRecord | null;
    fileList: UploadFile[];
    onFileListChange: (fileList: UploadFile[]) => void;
    onSubmit: () => void;
    onCancelEdit: () => void;
}

export const CustomerCareForm: React.FC<CustomerCareFormProps> = ({
    careType,
    form,
    loading,
    editingRecord,
    fileList,
    onFileListChange,
    onSubmit,
    onCancelEdit,
}) => {
    return (
        <Card>
            <Form form={form} layout="vertical">
                {careType === 'email' && (
                    <>
                        <Form.Item
                            name="email_type"
                            label="邮件类型"
                            rules={[{ required: true, message: '请选择邮件类型' }]}
                        >
                            <Select placeholder="请选择邮件类型">
                                <Select.Option value="thank_you">感谢邮件</Select.Option>
                                <Select.Option value="care">关怀邮件</Select.Option>
                                <Select.Option value="after_sales">售后邮件</Select.Option>
                                <Select.Option value="feedback">反馈邮件</Select.Option>
                                <Select.Option value="other">其他</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="subject"
                            label="邮件主题"
                            rules={[{ required: true, message: '请输入邮件主题' }]}
                        >
                            <Input placeholder="请输入邮件主题" />
                        </Form.Item>
                    </>
                )}

                {careType === 'after_sales_card' && (
                    <Form.Item name="subject" label="售后卡标题">
                        <Input placeholder="请输入售后卡标题（可选）" />
                    </Form.Item>
                )}

                <Form.Item
                    name="content"
                    label={careType === 'email' ? '邮件内容' : '售后卡内容'}
                    rules={[{ required: true, message: '请输入内容' }]}
                >
                    <TextArea
                        rows={8}
                        placeholder={careType === 'email' ? '请输入邮件正文...' : '请输入售后卡文字内容...'}
                    />
                </Form.Item>

                <Form.Item name="notes" label="备注说明">
                    <TextArea rows={3} placeholder="内部备注..." />
                </Form.Item>

                <Form.Item label="附件">
                    <Upload
                        fileList={fileList}
                        beforeUpload={() => false}
                        onChange={({ fileList }) => onFileListChange(fileList)}
                        multiple
                    >
                        <Button icon={<UploadOutlined />}>
                            {careType === 'email' ? '上传附件 (PDF, Word等)' : '上传售后卡图片/PDF'}
                        </Button>
                    </Upload>
                </Form.Item>

                <Form.Item>
                    <Space>
                        <Button type="primary" onClick={onSubmit} loading={loading}>
                            {editingRecord ? '更新' : '保存'}
                        </Button>
                        {editingRecord && <Button onClick={onCancelEdit}>取消编辑</Button>}
                    </Space>
                </Form.Item>
            </Form>
        </Card>
    );
};
